var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2705 22.75C6.34051 22.75 1.52051 17.93 1.52051 12C1.52051 6.07 6.34051 1.25 12.2705 1.25C18.2005 1.25 23.0205 6.07 23.0205 12C23.0205 17.93 18.2005 22.75 12.2705 22.75ZM12.2705 2.75C7.17051 2.75 3.02051 6.9 3.02051 12C3.02051 17.1 7.17051 21.25 12.2705 21.25C17.3705 21.25 21.5205 17.1 21.5205 12C21.5205 6.9 17.3705 2.75 12.2705 2.75Z",
    fill: "#00A14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9802 15.93C15.8502 15.93 15.7202 15.9 15.6002 15.82L12.5002 13.97C11.7302 13.51 11.1602 12.5 11.1602 11.61V7.51001C11.1602 7.10001 11.5002 6.76001 11.9102 6.76001C12.3202 6.76001 12.6602 7.10001 12.6602 7.51001V11.61C12.6602 11.97 12.9602 12.5 13.2702 12.68L16.3702 14.53C16.7302 14.74 16.8402 15.2 16.6302 15.56C16.4802 15.8 16.2302 15.93 15.9802 15.93Z",
    fill: "#00A14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b38d8acf9f2015f26b4d092b8e36b49e.svg";
export { ForwardRef as ReactComponent };